module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/course-2-photo-13-e35c12e2e79f2d7ee9e047d4b5672eee.webp";